import {
  Container,
  Box,
  Grid,
  IconButton,
  Link,
  Hidden,
  Button,
  Typography,
  Paper,
} from "@mui/material";
// import useStyles from "./styles";

import { CardElement } from "@stripe/react-stripe-js";
import { useSharedBookReducer } from "../state";
import { useFormContext } from "react-hook-form";

const Item = ({ title, type }) => {
  const [bookState, dispatch] = useSharedBookReducer();
  const { setValue } = useFormContext();

  const selected = bookState.m.type === type ? true : false;

  // console.log("Selected:", selected, type);
  const setMainType = () => {
    setValue("type", type);
    dispatch({
      type: "MERGE",
      payload: {
        m: { type },
      },
    });
  };

  return (
    <Grid item md={2} xs={4}>
      <Box
        sx={{
          backgroundColor: selected ? "#317e5c" : "#ffffff",
          color: selected ? "#ffffff" : "#4a4a4a",
          fontWeight: selected ? 600 : 400,
          borderRadius: "6px",
          boxShadow:
            "0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1)",
          display: "block",
          padding: "1.25rem",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          userSelect: "none",
          "&:hover": {
            boxShadow: "0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px #317e5c",
          },

          // a.box:active {
          //   box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.2), 0 0 0 1px #3273dc; }
        }}
        variant="outlined"
        onClick={setMainType}
      >
        <div>{title}</div>
      </Box>
    </Grid>
  );
};
const MainType = (props) => {
  const { register } = useFormContext();

  const [bookState, dispatch] = useSharedBookReducer();

  // console.log("MAINTYPE:", bookState.m.type);
  return (
    <>
      <input
        {...register("main", { shouldUnregister: true })}
        type="hidden"
        defaultValue={"surf"}
      />
      <input
        {...register("type", { shouldUnregister: true })}
        type="hidden"
        defaultValue={bookState.m.type}
      />
      {/* <input
        type="radio"
        name="type"
        value={bookState.m.type}
        style={{ display: "none" }}
      ></input> */}
      <Grid container spacing={2} wrap={"wrap"}>
        <Item title="Private Single" type="single" />
        <Item title="Private Group" type="group" />
        <Item title="Big Group" type="large-group" />
        <Item title="Join a Group" type="join" />
        <Item title="Corporate" type="corp" />
        <Item title="SurFit Class" type="surfit" />
      </Grid>
    </>
  );
};

export default MainType;
